import React, { useState, useEffect, useContext } from "react";
import { Modal, Box, TextField, Button, Typography } from "@mui/material";
import DataContext from "../context/users/DataContextCopy";
import { useNavigate } from "react-router-dom";

function UserCheckModal({ open, handleClose }) {
  const navigate = useNavigate();
  const { setMyName, setMyCall, userChecked, error, setError } =
    useContext(DataContext);
  const [checkName, setCheckName] = useState("");
  const [checkPhone, setCheckPhone] = useState("");

  const [isMobile, setIsMobile] = useState(false);

  const style = {
    position: "absolute",
    top: "45%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: "16px",
    maxHeight: "500px",
    overflowX: "auto",
  };

  // 모바일 화면 스타일
  const mobileStyle = {
    ...style, // 기존 스타일을 모두 상속
    width: "90%", // 모바일 화면에서는 가로폭을 100%로 설정
    top: "53%",
    p: "10px 5px",
    height: "300px",
  };

  const checkSubmit = () => {
    if (!checkName || !checkPhone) {
      setError("이름과 전화번호를 입력해주세요.");
      return;
    }

    setError(""); // 에러 초기화
    setMyName(checkName); // 이름을 컨텍스트에 저장
    setMyCall(checkPhone); // 전화번호를 컨텍스트에 저장

    navigate("/DeclareList");
    handleClose(); // 모달 닫기
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 800);
    };
    // 초기 로드 시 및 윈도우 크기 변경 시 호출
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      checkSubmit();
    }
  };

  return (
    <Modal open={open} onClose={handleClose} aria-labelledby='modal-modal-title' aria-describedby='modal-modal-description'>
      <Box sx={isMobile ? mobileStyle : style}>
        <Typography id='modal-modal-title' variant='h6' component='h2'>
          내 민원 확인
        </Typography>
        <TextField
          fullWidth
          label='이름'
          variant='outlined'
          autoFocus
          autoComplete='off'
          value={checkName}
          onChange={e => setCheckName(e.target.value)}
          margin='normal'
        />
        <TextField
          fullWidth
          label='전화번호'
          variant='outlined'
          autoComplete='off'
          value={checkPhone}
          onChange={e => setCheckPhone(e.target.value)}
          margin='normal'
          onKeyDown={handleKeyDown}
        />
        <Button variant='contained' color='primary' onClick={checkSubmit} fullWidth>
          확인
        </Button>
        {error && <Typography color='error'>{error}</Typography>}
      </Box>
    </Modal>
  );
}

export default UserCheckModal;
